<template>
	<v-container fluid class="problema-section pa-12">
		<v-container class="pa-10">
			<v-row justify="center">
				<v-col cols="12" md="10" class="text-center">
					<div class="problema-label">PROBLEMAS COMUNS</div>
					<h2 class="problema-title">
						Sua transportadora ainda<br>
						sofre com isso?
					</h2>
					<p class="problema-subtitle">
						A maioria das transportadoras perde dinheiro e tempo com processos ultrapassados.
					</p>
				</v-col>
			</v-row>
			<v-row justify="center" class="mt-8">
				<v-col cols="12" md="4" class="mb-6">
					<div class="problema-card">
						<div class="problema-card-header">
							<v-icon color="#e11d48" class="problema-icon">mdi-clipboard-text-outline</v-icon>
							<div class="problema-card-title">Controle manual e planilhas</div>
						</div>
						<div class="problema-card-desc">Horas perdidas preenchendo planilhas desatualizadas que geram erros e retrabalho constante.</div>
					</div>
				</v-col>
				<v-col cols="12" md="4" class="mb-6">
					<div class="problema-card">
						<div class="problema-card-header">
							<v-icon color="#e11d48" class="problema-icon">mdi-file-document-outline</v-icon>
							<div class="problema-card-title">Papelada e documentos perdidos</div>
						</div>
						<div class="problema-card-desc">Documentos espalhados em pastas, gavetas e e-mails, impossível encontrar quando mais precisa.</div>
					</div>
				</v-col>
				<v-col cols="12" md="4" class="mb-6">
					<div class="problema-card">
						<div class="problema-card-header">
							<v-icon color="#e11d48" class="problema-icon">mdi-alert-circle-outline</v-icon>
							<div class="problema-card-title">Multas por documentação vencida</div>
						</div>
						<div class="problema-card-desc">Sem alertas automáticos, vencimentos passam despercebidos e geram multas pesadas.</div>
					</div>
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-col cols="12" md="4">
					<div class="problema-card">
						<div class="problema-card-header">
							<v-icon color="#e11d48" class="problema-icon">mdi-currency-usd-off</v-icon>
							<div class="problema-card-title">Zero controle de despesas</div>
						</div>
						<div class="problema-card-desc">Motoristas gastam sem registro claro. Fim do mês é uma surpresa — quase sempre negativa.</div>
					</div>
				</v-col>
				<v-col cols="12" md="4">
					<div class="problema-card">
						<div class="problema-card-header">
							<v-icon color="#e11d48" class="problema-icon">mdi-phone-off-outline</v-icon>
							<div class="problema-card-title">Comunicação falha com motoristas</div>
						</div>
						<div class="problema-card-desc">Ligações, mensagens soltas no WhatsApp. Informações se perdem e decisões atrasam.</div>
					</div>
				</v-col>
			</v-row>
		</v-container>
	</v-container>
</template>

<script>
export default {
	name: "SecaoProblema"
}
</script>

<style scoped>
.problema-section {
	/* background: radial-gradient(circle at center, #0f172a, #020617); */
	min-height: 55vh;
	display: flex;
	align-items: center;
	color: white;
}

.problema-label {
	color: #e11d48;
	font-size: 11px;
	font-weight: bold;
	letter-spacing: 1.2px;
	margin-bottom: 10px;
}

.problema-title {
	font-size: 26px;
	font-weight: 800;
	line-height: 1.15;
	margin-bottom: 10px;
}

.problema-subtitle {
	color: #94a3b8;
	font-size: 13px;
	margin-bottom: 18px;
}

.problema-card {
	background: rgba(255,255,255,0.01);
	border: 1px solid #e11d48;
	border-radius: 10px;
	padding: 12px 10px 10px 10px;
	color: #fff;
	min-height: 80px;
	box-shadow: 0 0 16px rgba(0,0,0,0.04);
	transition: box-shadow 0.2s;
	text-align: left;
	max-width: 320px;
	margin-left: auto;
	margin-right: auto;
}
.problema-card:hover {
	box-shadow: 0 0 20px #e11d48;
}
.problema-card-header {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 2px;
}
.problema-icon {
	background: #e11d4814;
	border-radius: 8px;
	padding: 4px;
	font-size: 18px;
	margin-bottom: 0;
}
.problema-card-title {
	font-weight: bold;
	font-size: 12px;
	margin-bottom: 0;
}
.problema-card-desc {
	color: #cbd5e1;
	font-size: 11px;
}
</style>